import React from 'react';

const CardLoading = () => {
    return (
        <div className="flex flex-col m-2 rounded shadow-md w-60 sm:w-80 animate-pulse h-96">
            <div className="h-48 rounded-t bg-slate-300 dark:bg-gray-700"></div>
            <div className="flex-1 px-4 py-8 space-y-4 sm:p-8 dark:bg-gray-900">
                <div className="w-full h-6 rounded bg-slate-300 dark:bg-gray-700"></div>
                <div className="w-full h-6 rounded bg-slate-300 dark:bg-gray-700"></div>
                <div className="w-3/4 h-6 rounded bg-slate-300 dark:bg-gray-700"></div>
            </div>
        </div>
    );
};

export default CardLoading;